import { Component, inject, Input, OnInit } from '@angular/core';
import { filter } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';
import { DeviceService } from 'projects/max/dfup-storeupweb-fe/src/app/service/device.service';

@Component({
  selector: 'app-menu-item',
  template: ''
})
export class MenuItemComponent implements OnInit {
  @Input() item!: Item;
  active = false;
  public deviceSvc_ = inject(DeviceService);
  private router_ = inject(Router);

  ngOnInit() {
    this.router_.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(event => {
        this.deviceSvc_.hamburgerMenu = false;
        this.active = this.isUrl((event as NavigationEnd).urlAfterRedirects);
      });
    this.active = this.isUrl(this.router_.url);
  }

  private isUrl(url: string): boolean {
    return url.includes(this.item.href);
  }
}

export interface Item {
  href: string;
  label: string;
}
